<script>
	import { Link, navigate } from "svelte-routing";
	import GoogleMaps from '../components/GoogleMaps.svelte';
	import Modal from '../components/Modal.svelte';
	
	let userCard;
	let showModal = false;
	export let empleados, indexPersona;
	const buscaId = (indexPersona) =>{
		let demo = empleados.filter(empleado => indexPersona == empleado.id)
		if(demo.length == 0){
			navigate(`/`, {replace: true});
		}
		return demo[0] ;
	}

	let vcard = buscaId(indexPersona);

	const dirigirVcard = (id) =>{
		let demo = empleados.filter(empleado => id.indexPersona == empleado.id)
		userCard = demo[0]
		indexPersona = userCard.id;
		navigate(`/card/${userCard.id}`, {replace: true});
	}

</script>

<div class="body">
	<div class="bg-secondary cabecera">
		<span on:click={()=>dirigirVcard({indexPersona})}>
			<img class="arrow" src="../images/left-arrow.png" alt="">
		</span>
		<img src="../images/poviard_white.png" alt="">
	</div>
	<div class="googleMaps">
		
		<GoogleMaps {vcard} {indexPersona}></GoogleMaps>

	</div>
	<div class="group-datos info">
		<div class="l-datos">
			<div class="logo">
				<img src="../images/marker_1.png" alt="">
			</div>
			<div class="data">
				<div class="text mb-2">
					{vcard.direccion}
				</div>
				<a class="blue" on:click="{() => showModal = true}">
					<small>VIEW ADDRESS</small>
				</a>
			</div>
		</div>
	</div>
</div>

{#if showModal}
<Modal on:close="{() => showModal = false}">
	<h4 slot="header">
		Use Google Maps
	</h4>
	<div slot="body">
		<p>
			Directions will be opened on Google Maps. Do you wish to continue?
		</p>		
	</div>
	<div slot="footer">
		<a class="btn btn-primary" href="https://www.google.com/maps/search/?api=1&query={vcard.direccion}" target="_blank">Maps</a>
		<button class="btn btn-primary" on:click="{() => showModal = false}">Close</button>
	</div>
</Modal>
{/if}


<style lang="scss">
a{
	text-decoration: none;
}
.cabecera{
	padding: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	span{
		position: absolute;
		left: 10px;
		cursor: pointer;
	}
}
.googleMaps{
	height: 60vh;
}
.info{
	padding-top: 25px;
	padding-bottom: 25px;
}
.arrow{
	width: 25px;
}
</style>